import { Title } from '../../../components/typography/Heading';
import Image from '../../../components/image/Image';
import Spinner from '../../../components/spinner/Spinner';
import { useState } from 'react';
import { CardBase } from '@sb1/ffe-cards-react';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';
import NativeShareButton from '../NativeShareButton';
import styles from './ShareInstructionsModal.module.less';
import { useSelector } from 'react-redux';
import { ModalBlock } from '@sb1/ffe-modals-react';
import { Heading2, BodyText, StrongText } from '@sb1/ffe-core-react';
import { InputWithCopyButton } from '../../../components/input-with-copy/InputWithCopyButton';

const SharingGuideStep = ({ title, text, imageSrc }) => {
    return (
        <CardBase className={styles.sharingStepContainer}>
            <div className={styles.sharingStepTextContainer}>
                <StrongText>{title}</StrongText>
                <BodyText>{text}</BodyText>
            </div>
            <div>
                <Image className={styles.sharingStepImage} src={imageSrc} />
            </div>
        </CardBase>
    );
};

export default function InstagramShareInstructionsModalBlock({
    urlToShare,
    projectTitle,
    projectId,
    trackingProperties,
    onBack,
    subprojectId,
    tradingCardImageUrl,
}) {
    const [loadingSharingImage, setLoadingSharingImage] = useState(true);
    const transactionForGiverInfo = useSelector((state) => state.transactions.transactionForGiverInfo);
    const subproject = subprojectId || transactionForGiverInfo?.subproject_id;

    const imageSrc =
        tradingCardImageUrl ??
        `/api/public/project/${projectId}/shareImage${subproject ? `?subprojectId=${subproject}` : ''}`;

    return (
        <ModalBlock>
            <Heading2 id="share-modal-title">Del på Instagram</Heading2>
            <div className={styles.container}>
                {loadingSharingImage && <Spinner />}
                <div className={styles.photoContainer}>
                    <Image
                        className={styles.previewPhoto}
                        src={imageSrc}
                        title={'Last ned og del på Instagram'}
                        alt={'Delingsbilde til Instagram'}
                        onLoad={() => setLoadingSharingImage(false)}
                    />
                </div>
                <Title className={styles.guideTitle}>Sånn legger du lenken på Instagram-historien:</Title>
                <SharingGuideStep
                    title={'Steg 1'}
                    text={'Trykk på klistremerket'}
                    imageSrc={'sharing/instaStep1.svg'}
                />
                <SharingGuideStep
                    title={'Steg 2'}
                    text={'Velg lenke og lim den inn'}
                    imageSrc={'sharing/instaStep2.svg'}
                />
                <SharingGuideStep
                    title={'Steg 3'}
                    text={'Plasser lenken på bildet'}
                    imageSrc={'sharing/instaStep3.svg'}
                />
            </div>
            <div>
                <InputWithCopyButton
                    label={'Lenke til spleisen'}
                    prettyUrlToShare={urlToShare}
                    trackEventFunction={() =>
                        trackEvent('support', 'share-after-instructions-copy', {
                            channel: 'instagram',
                            ...trackingProperties,
                        })
                    }
                />
            </div>
            <NativeShareButton
                onBack={onBack}
                text={'Åpne Instagram'}
                urlToShare={urlToShare}
                titleToShare={projectTitle}
                shareImageUrl={tradingCardImageUrl ? imageSrc : null}
            />
        </ModalBlock>
    );
}
